import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { customStatusInterface } from '../custom-status.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { environment } from 'src/environments/environment';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { statusInterface } from 'src/app/util/interfaces/statusInterface';

@Injectable({
	providedIn: 'root',
})
export class CustomStatusService {
	private getCustomStatusUrl = environment.baseApiUrl + 'register/customer/status';
	private postCustomStatusUrl = environment.baseApiUrl + 'register/customer/status';
	private putCustomStatusUrl = environment.baseApiUrl + 'register/customer/status';

	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getAllStatus(): Observable<statusInterface[]> {
		return this.http.get<statusInterface[]>(this.getCustomStatusUrl, { headers: this.headers });
	}

	createCustomStatus(customStatus: statusInterface): Observable<statusInterface> {
		return this.http.post<statusInterface>(this.postCustomStatusUrl, customStatus, { headers: this.headers });
	}

	updateCustomStatus(customStatus: statusInterface): Observable<statusInterface> {
		return this.http.put<statusInterface>(this.putCustomStatusUrl, customStatus, { headers: this.headers });
	}
}
